import { render, staticRenderFns } from "./heading.vue?vue&type=template&id=a56551e8&scoped=true"
import script from "./heading.vue?vue&type=script&lang=js"
export * from "./heading.vue?vue&type=script&lang=js"
import style0 from "./heading.vue?vue&type=style&index=0&id=a56551e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56551e8",
  null
  
)

export default component.exports